/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import "./movie.css";
import classNames from "classnames";
import axios from "axios";
import { BorderTopOutlined } from "@ant-design/icons";
import { notification } from "antd";

export default function Movie() {
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement) => {
    api.info({
      message: `温馨提示`,
      description: "暂时没有更多宠物数据了!",
      placement,
      duration: 2,
    });
  };

  // 导航栏默认选项
  const [watch, setWatch] = useState(1);
  // 鼠标移入事件
  const [enter, setEnter] = useState(0);

  useEffect(() => {}, [watch, enter]);

  const [pet, setPet] = useState([]);
  useEffect(() => {
    axios.get("http://www.itemev.com/home/Pet").then((response) => {
      setPet(response.data);
    });
  }, []);

  // 娱乐
  const [yule, setYule] = useState([]);
  const [yuenter, setYuenter] = useState(0);
  const [yuhuan, setYuhuan] = useState(0);
  const [rank, setRank] = useState(false);

  // 财经
  const [cai, setCai] = useState([]);
  const [caienter, setCaienter] = useState(0);

  // 军事
  const [jun, setJun] = useState([]);
  const [junenter, setJunenter] = useState(0);
  const [junhuan, setJunhuan] = useState(0);
  const [junrank, setJunrank] = useState(false);
  return (
    <div className="movie">
      {/* 顶部的导航栏 */}
      <div className="movie-menu">
        {/* 导航栏里的每一个选项 */}
        <div className="movie-menulist">
          {watch === 1 && <div className="movie-br"></div>}
          <span
            className={classNames({ "color-green": watch === 1 })}
            onClick={() => {
              setWatch(1);
            }}
          >
            宠物
          </span>
        </div>
        <div className="movie-menulist">
          {watch === 2 && <div className="movie-br"></div>}
          <span
            className={classNames({ "color-green": watch === 2 })}
            onClick={() => {
              axios.get("http://www.itemev.com/home/Yule").then((response) => {
                setYule(response.data);
              });
              setWatch(2);
            }}
          >
            娱乐
          </span>
        </div>
        <div className="movie-menulist">
          {watch === 3 && <div className="movie-br"></div>}
          <span
            className={classNames({ "color-green": watch === 3 })}
            onClick={() => {
              axios
                .get("http://www.itemev.com/home/Caijing")
                .then((response) => {
                  setCai(response.data);
                });
              setWatch(3);
            }}
          >
            财经
          </span>
        </div>
        <div className="movie-menulist">
          {watch === 4 && <div className="movie-br"></div>}
          <span
            className={classNames({ "color-green": watch === 4 })}
            onClick={() => {
              axios
                .get("http://www.itemev.com/home/Junshi")
                .then((response) => {
                  setJun(response.data);
                });
              setWatch(4);
            }}
          >
            军事
          </span>
        </div>
      </div>

      {/* 排行榜盒子 */}
      {watch === 1 && (
        <div className="movie-rank">
          {pet !== [] && (
            <>
              {pet.map((item, index) => {
                return (
                  <div
                    className={classNames("movie-ranklist", {
                      "movie-ranklist-hidden": index === enter,
                    })}
                    key={item.coverURL}
                    onMouseEnter={() => {
                      setEnter(index);
                    }}
                  >
                    {index !== enter && (
                      <>
                        {/* 排名 */}
                        <div className="movie-ranklist-first">
                          <span
                            className={classNames({
                              "color-red": index + 1 === 1,
                              "color-orange": index + 1 === 2,
                              "color-yellow": index + 1 === 3,
                            })}
                          >
                            {index + 1}
                          </span>
                        </div>
                        {/* 电影名 */}
                        <div className="movie-ranklist-next">
                          <span>{item.name}</span>
                        </div>
                        {/* 热度 */}
                        <div className="movie-ranklist-three">
                          <span>{item.price}</span>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </>
          )}

          {/* 鼠标移入之后的盒子 */}
          {pet !== [] && (
            <>
              {pet.map((todo, index) => {
                if (enter === index) {
                  return (
                    <div
                      className={classNames("movie-rankimg", {
                        "movie-position-one": index === 0,
                        "movie-position-two": index === 1,
                        "movie-position-three": index === 2,
                        "movie-position-four": index === 3,
                        "movie-position-five": index === 4,
                        "movie-position-six": index === 5,
                        "movie-position-seven": index === 6,
                        "movie-position-eight": index === 7,
                        "movie-position-nine": index === 8,
                        "movie-position-ten": index === 9,
                      })}
                      key={todo.name}
                      onClick={() => {
                        window.open(todo.url);
                      }}
                    >
                      <img src={todo.coverURL} alt="" className="movie-img" />
                      <div className="movie-rankimg-content">
                        <div className="movie-rankimg-first">
                          <span>{todo.name}</span>
                        </div>
                        <div className="movie-rankimg-next">
                          <span>地区:{todo.nation}</span>
                        </div>
                        <div className="movie-rankimg-next">
                          <span>年龄:{todo.life}</span>
                        </div>
                        <div className="movie-rankimg-next">
                          <span>性格:{todo.characters}</span>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}
        </div>
      )}

      {watch === 2 && (
        <div className="movie-rank">
          {yule !== [] && (
            <>
              {yule.slice(yuhuan, yuhuan + 10).map((item, index) => {
                return (
                  <div
                    className={classNames("movie-ranklist", {
                      "movie-ranklist-hidden": index === yuenter,
                    })}
                    key={item.title}
                    onMouseEnter={() => {
                      setYuenter(index);
                    }}
                  >
                    {index !== yuenter && (
                      <>
                        {/* 排名 */}
                        <div className="movie-ranklist-first-yule">
                          <span
                            className={classNames({
                              "color-red": index + 1 === 1,
                              "color-orange": index + 1 === 2,
                              "color-yellow": index + 1 === 3,
                            })}
                          >
                            {rank === false && <>{index + 1}</>}
                            {rank === true && <>{index + 11}</>}
                          </span>
                        </div>
                        {/* 电影名 */}
                        <div className="movie-ranklist-next-yule">
                          <span>{item.title}</span>
                        </div>
                        {/* 热度 */}
                      </>
                    )}
                  </div>
                );
              })}
            </>
          )}

          {/* 鼠标移入之后的盒子 */}
          {yule !== [] && (
            <>
              {yule.slice(yuhuan, yuhuan + 10).map((todo, index) => {
                if (yuenter === index) {
                  return (
                    <div
                      className={classNames("movie-rankimg", {
                        "movie-position-one": index === 0,
                        "movie-position-two": index === 1,
                        "movie-position-three": index === 2,
                        "movie-position-four": index === 3,
                        "movie-position-five": index === 4,
                        "movie-position-six": index === 5,
                        "movie-position-seven": index === 6,
                        "movie-position-eight": index === 7,
                        "movie-position-nine": index === 8,
                        "movie-position-ten": index === 9,
                      })}
                      key={todo.id}
                      onClick={() => {
                        window.open(todo.url);
                      }}
                    >
                      <img src={todo.picUrl} alt="" className="movie-img" />
                      <div className="movie-rankimg-content">
                        <div className="movie-rankimg-first">
                          <span>{todo.title}</span>
                        </div>
                        <div className="movie-rankimg-next">
                          <span>作者:{todo.source}</span>
                        </div>
                        <div className="movie-rankimg-next">
                          <span>时间:{todo.ctime}</span>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}
        </div>
      )}

      {watch === 3 && (
        <div className="movie-rank">
          <div className="movie-rank">
            {cai !== [] && (
              <>
                {cai.map((item, index) => {
                  return (
                    <div
                      className={classNames("movie-ranklist", {
                        "movie-ranklist-hidden": index === caienter,
                      })}
                      key={item.url}
                      onMouseEnter={() => {
                        setCaienter(index);
                      }}
                    >
                      {index !== caienter && (
                        <>
                          {/* 排名 */}
                          <div className="movie-ranklist-first-yule">
                            <span
                              className={classNames({
                                "color-red": index + 1 === 1,
                                "color-orange": index + 1 === 2,
                                "color-yellow": index + 1 === 3,
                              })}
                            >
                              {index + 1}
                            </span>
                          </div>
                          {/* 电影名 */}
                          <div className="movie-ranklist-next-yule">
                            <span>{item.title}</span>
                          </div>
                          {/* 热度 */}
                        </>
                      )}
                    </div>
                  );
                })}
              </>
            )}

            {/* 鼠标移入之后的盒子 */}
            {cai !== [] && (
              <>
                {cai.map((todo, index) => {
                  if (caienter === index) {
                    return (
                      <div
                        className={classNames("movie-rankimg", {
                          "movie-position-one": index === 0,
                          "movie-position-two": index === 1,
                          "movie-position-three": index === 2,
                          "movie-position-four": index === 3,
                          "movie-position-five": index === 4,
                          "movie-position-six": index === 5,
                          "movie-position-seven": index === 6,
                          "movie-position-eight": index === 7,
                          "movie-position-nine": index === 8,
                          "movie-position-ten": index === 9,
                        })}
                        key={todo.title}
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      >
                        <img src={todo.picUrl} alt="" className="movie-img" />
                        <div className="movie-rankimg-content">
                          <div className="movie-rankimg-first">
                            <span>{todo.title}</span>
                          </div>
                          <div className="movie-rankimg-next">
                            <span>作者:{todo.source}</span>
                          </div>
                          <div className="movie-rankimg-next">
                            <span>时间:{todo.ctime}</span>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </>
            )}
          </div>
        </div>
      )}
      {watch === 4 && (
        <div className="movie-rank">
          <div className="movie-rank">
            <div className="movie-rank">
              {jun !== [] && (
                <>
                  {jun.slice(junhuan, junhuan + 10).map((item, index) => {
                    return (
                      <div
                        className={classNames("movie-ranklist", {
                          "movie-ranklist-hidden": index === junenter,
                        })}
                        key={item.url}
                        onMouseEnter={() => {
                          setJunenter(index);
                        }}
                      >
                        {index !== junenter && (
                          <>
                            {/* 排名 */}
                            <div className="movie-ranklist-first-yule">
                              <span
                                className={classNames({
                                  "color-red": index + 1 === 1,
                                  "color-orange": index + 1 === 2,
                                  "color-yellow": index + 1 === 3,
                                })}
                              >
                                {junrank === false && <>{index + 1}</>}
                                {junrank === true && <>{index + 11}</>}
                              </span>
                            </div>
                            {/* 电影名 */}
                            <div className="movie-ranklist-next-yule">
                              <span>{item.title}</span>
                            </div>
                            {/* 热度 */}
                          </>
                        )}
                      </div>
                    );
                  })}
                </>
              )}

              {/* 鼠标移入之后的盒子 */}
              {jun !== [] && (
                <>
                  {jun.slice(junhuan, junhuan + 10).map((todo, index) => {
                    if (junenter === index) {
                      return (
                        <div
                          className={classNames("movie-rankimg", {
                            "movie-position-one": index === 0,
                            "movie-position-two": index === 1,
                            "movie-position-three": index === 2,
                            "movie-position-four": index === 3,
                            "movie-position-five": index === 4,
                            "movie-position-six": index === 5,
                            "movie-position-seven": index === 6,
                            "movie-position-eight": index === 7,
                            "movie-position-nine": index === 8,
                            "movie-position-ten": index === 9,
                          })}
                          key={todo.uniquekey}
                          onClick={() => {
                            window.open(todo.url);
                          }}
                        >
                          {todo.thumbnail_pic_s === "" && (
                            <img
                              src={require("./img/none.jpg")}
                              alt=""
                              className="movie-img"
                            />
                          )}
                          {todo.thumbnail_pic_s !== "" && (
                            <img
                              src={todo.thumbnail_pic_s}
                              alt=""
                              className="movie-img"
                            />
                          )}

                          <div className="movie-rankimg-content">
                            <div className="movie-rankimg-first">
                              <span>{todo.title}</span>
                            </div>
                            <div className="movie-rankimg-next">
                              <span>作者:{todo.author_name}</span>
                            </div>
                            <div className="movie-rankimg-next">
                              <span>时间:{todo.date}</span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {/* 换一换 */}
      <div className="movie-trade">
        <img src={require("./img/huan.png")} alt="" className="movie-huan" />
        <span
          onClick={() => {
            if (watch === 1) {
              openNotification("top");
            }
            if (watch === 2) {
              if (yuhuan === 10) {
                setYuhuan(yuhuan - 10);
              } else {
                setYuhuan(10);
              }
              setRank(!rank);
            }
            if (watch === 3) {
            }
            if (watch === 4) {
              if (junhuan === 10) {
                setJunhuan(junhuan - 10);
              } else {
                setJunhuan(10);
              }
              setJunrank(!junrank);
            }
          }}
          icon={<BorderTopOutlined />}
        >
          换一换
        </span>
        {contextHolder}
      </div>
    </div>
  );
}
